// extracted by mini-css-extract-plugin
module.exports = {"container":"FileUpload_container__3s-nE","upload":"FileUpload_upload__3ICex","arrow":"FileUpload_arrow__3nAHu","addImage":"FileUpload_addImage__1GICO"};